import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import type { ButtonHTMLAttributes } from 'react';
import type { ButtonProps } from '../../components/button/types';
import { GLOBAL_ICONS } from '../../util/vars';
import { Button } from '../../components';

type Ref = HTMLButtonElement;
type HTMLProps = Omit<ButtonHTMLAttributes<Ref>, 'color'>;
interface Props extends ButtonProps, HTMLProps {}

const ClearButtonModal = ({ ...other }: Props): JSX.Element => {
  const { translate } = useI18n();

  return (
    <Button
      isOutline
      icon={GLOBAL_ICONS.delete}
      color={'error'}
      data-cy="modal-button-clear"
      {...other}
    >
      {translate('pages.REPORTS.FILTERS.MODAL.clear')}
    </Button>
  );
};

export default ClearButtonModal;
